import React from 'react';
import { observer } from "mobx-react";
import { Form, InputNumber, Space } from 'antd';

@observer
export class VariantWithSizeSpecific extends React.Component {
    render() {
        const { variant, onChange } = this.props;
        return (
            <Form.Item label="Size (inches)">
                <Space>
                    <InputNumber
                        size="small"
                        step={0.1}
                        placeholder="Width"
                        value={variant.typeSpecific.width}
                        onChange={(v) => onChange('width', v)}
                        addonBefore="W"
                        style={{ width: 110 }}
                    />
                    <InputNumber
                        size="small"
                        step={0.1}
                        placeholder="Height"
                        value={variant.typeSpecific.height}
                        onChange={(v) => onChange('height', v)}
                        addonBefore="H"
                        style={{ width: 110 }}
                    />
                </Space>
            </Form.Item>
        );
    }
}
